import { Checkbox } from '@mui/material'; // Keep MUI Checkbox for custom expand/collapse icons
import { useDispatch, useSelector } from 'react-redux';
import type { VFC } from 'react';

import * as IssuesV2Store from '../../../redux/issuesV2';
import { Icon, icons } from '../../generic';
import { ICON_SIZE } from '../../generic/Icon/icon-constants';

import css from './IssuesExpandAllButton.module.less';

/**
 * An expand-all button for the revision table header.
 * Uses MUI Checkbox with custom icons instead of our custom Checkbox component
 * because it needs custom expand/collapse icons.
 *
 * TODO: consider converting this into a generic button that takes in state and
 * callback.  That'll make it easy to share the styles.
 */
const IssuesExpandAllButton: VFC = () => {
  const dispatch = useDispatch();
  const grouping = useSelector(IssuesV2Store.selectors.getGrouping);
  const isAnyRevisionExpanded = useSelector(IssuesV2Store.selectors.isAnyRevisionExpanded);

  if (grouping !== 'revision') {
    return null;
  }

  return (
    <div>
      <Checkbox
        className={css.iconCheckbox}
        checked={isAnyRevisionExpanded}
        color="default"
        icon={<Icon icon={icons.arrowsFromLine} size={ICON_SIZE.SM} />}
        checkedIcon={<Icon icon={icons.arrowsToLine} size={ICON_SIZE.SM} />}
        disableFocusRipple
        onClick={() =>
          isAnyRevisionExpanded
            ? dispatch(IssuesV2Store.actions.collapseAllIssueRevisions())
            : dispatch(IssuesV2Store.actions.expandAllRevisions())}
      />
    </div>
  );
};

export default IssuesExpandAllButton;
